import React from "react";
import { Redirect } from "react-router-dom"
import { connect } from "react-redux";
import { enviarComentarioFirma, getRecibos, publicarLote, aceptarEmpleado, getRecibo } from "./RecibosService";
import "../../styles/Empresa.css";
import { URL, aceptar, aceptarRechazar, firmaColaborador, firmaColaboradorRechazar, getAuthorizationHeader } from '../../constans/constants';
import { rechazarLote } from '../recibos/RecibosService';
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Modal, Form, Button, Row, Col } from 'react-bootstrap'
import PinEmpleado from "../recibos/PinEmpleado";
import axios from "axios";
import SeleccionPca from "../pca/SeleccionPca";
import LoginPsa from "../pca/LoginPsa";
import checkCircle from '../../styles/icons/check-circle.svg'
import xCircle from '../../styles/icons/x-circle.svg'
import safeRedirectManager from '../seguridad/SafeRedirectComponent';
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import ModalMensajePersonalizado from "../componentes/modales/ModalMensajesPersonalizado";
import ModalRechazarRecibo from "./ModalRechazarRecibo";
import ModalAceptarLote from "../lotes/ModalAceptarLote";

class ReciboEmpleado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Firmar recibo",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      tipoFirma: "",
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogPinOpen: localStorage.getItem("tokenIscert") != null ? true : false,
      open: false,
      openComentarioFirma: false,
      comentarioFirma: "",
      openMsgAceptarFirma: false,

      openMsgVentana: false,
      msgVentana: "",
      error: false,


      openPantallaCarga: false,
      msgPantallaCarga: "",

      openRechazar: false,
      mensajeRechazar: "",
      redirect: false,
      exito: false,
      isRechazado: false,
      validated: false,
      openSeleccionPca: false,
      openLoginPSA: false,

      formatoDocumento: "",
      loteRecibo: "",
      fecha: "",
      concepto: "",
      enableComentarioFirma: false,
      codFirmaColaborador: ""

    };

    this.modalRechazarRecibo = React.createRef();
    this.tableRef = React.createRef();
    this.modalSeleccionPsa = React.createRef();
    this.modalAceptarLote = React.createRef();
    this.modalMensaje = React.createRef();

    const psaActivos = null;
    let isRedirect = true;
    let pantallaAnterior = null;
    this.setPantallaAnterior();
  }

  componentWillUnmount() {
    if (this._pdfAbortController) {
      this._pdfAbortController.abort();
    }
    if (this._viewerWindow) {
      try {
        this._viewerWindow.document.removeEventListener('click', this.handlePDFClick);
        this._viewerWindow.document.removeEventListener('contextmenu', this.handlePDFRightClick);
      } catch (_) {}
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.tableRef.current && this.tableRef.current.onQueryChange();
    }

  }

  componentDidMount() {

    if (localStorage.getItem("status_tuid") != null) {
      if (localStorage.getItem("status_tuid") == "finished") {
        this.isRedirect = true;
        this.setState({
          msgVentana: "El documento se firmo con exito",
          openMsgVentana: true,
          exito: !false,
          error: false
        })
        localStorage.removeItem("status_tuid")
      } else if (localStorage.getItem("status_tuid") == "failed") {
        this.isRedirect = true;
        this.setState({
          msgVentana: "El documento no ha sido firmado porque se ha producido un error",
          openMsgVentana: true,
          exito: !true,
          error: true
        })
        localStorage.removeItem("status_tuid")
      } else if (localStorage.getItem("status_tuid") == "canceled") {
        this.isRedirect = true;
        this.setState({
          msgVentana: "El documento no ha sido firmado mediante la cancelación de su ejecución",
          openMsgVentana: true,
          exito: !true,
          error: true
        })
        localStorage.removeItem("status_tuid")
      }
    }
    getRecibo(this.props.match.params.idLote, this.props.match.params.idRecibo).then((res) => {
      this.psaActivos = res.datos.psaActivos
      this.setState({
        formatoDocumento: res.datos.formatoDocumento,
        loteRecibo: res.datos.loteRecibo,
        fecha: res.datos.fecha,
        concepto: res.datos.concepto,
        codFirmaColaborador: res.datos.codFirmaColaborador,
        tipoFirma: res.datos.codFirmaColaborador,
        enableComentarioFirma: res.datos.enableComentarioFirma
      })
    })
    this.initializePDFViewer().then(() => this.fetchPDF());
  }

  handlePDFClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
      // Aquí puedes manejar el enlace clickeado como desees
      safeRedirectManager.safeRedirect(target.href);
    }
  }

  handlePDFRightClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
    }
  }

  initializePDFViewer = () => {
    return new Promise((resolve) => {
      const viewerFrame = document.getElementById('pdf-js-viewer');
      if (!viewerFrame) return resolve();

      viewerFrame.addEventListener('load', () => {
        const viewerWindow = viewerFrame.contentWindow;
        if (!viewerWindow?.PDFViewerApplication) return resolve();

        viewerWindow.PDFViewerApplication.initializedPromise.then(() => {
          this._viewerWindow = viewerWindow;
          viewerWindow.document.addEventListener('click', this.handlePDFClick);
          viewerWindow.document.addEventListener('contextmenu', this.handlePDFRightClick);
          resolve();
        });
      }, { once: true });

      viewerFrame.src = "/mirecibo/visor/viewer.html?file=";
    });
  };

  fetchPDF = async () => {
    this._pdfAbortController = new AbortController();
    this.setState({ pdfLoading: true });
    try {
      const requestUrl = `${URL}recibo/lote/${this.props.match.params.idLote}/recibo/${this.props.match.params.idRecibo}`;
      const response = await axios.get(requestUrl, {
        ...getAuthorizationHeader(),
        responseType: 'arraybuffer',
        signal: this._pdfAbortController.signal
      });

      await this._viewerWindow.PDFViewerApplication.open({
        data: new Uint8Array(response.data)
      });
      this.setState({ pdfLoading: false });
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error('Error fetching PDF:', error);
        this.setState({ pdfError: 'Error al cargar el PDF', pdfLoading: false });
      }
    }
  };

  setPantallaAnterior = () => {
    return (localStorage.getItem("urlRaiz")).substring(localStorage.getItem("urlRaiz").indexOf("#") + 1);
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
  };

  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
    });
  };


  handleClosePsa = () => {
    this.setState({ openSeleccionPca: false })
  }


  handleMsgVentana = (value) => {
    this.setState({ msgVentana: "", openMsgVentana: value, redirect: this.isRedirect })
  }

  handleDialogPin = (open, data) => {

    if (localStorage.getItem("tokenIscert") == null) {
      this.setState({ openSeleccionPca: true });
      return;
    }

    localStorage.removeItem("tokenIscert")
    localStorage.removeItem("codigoClienteFirma")
    localStorage.removeItem("proveedorFirma")

    if (data && data.error) {
      this.setState({
        msgVentana: data.mensaje || "Se ha producido un error al cargar los datos de firma.",
        openMsgVentana: true,
        error: true,
        dialogPinOpen: false
      });
    } else {
      this.setState({ dialogPinOpen: open });
      this.props.history.push({
        pathname: '/recibo/firmar/' + (data.error ? 'error' : 'exito'),
        state: {
          descripcionLote: this.state.concepto,
          fechaImportacionLote: this.state.fecha,
          errorDetalle: data.error ? data.mensaje : null,
          comentarioFirma: this.state.enableComentarioFirma,
          backUrl: this.props.location.pathname
        }
      });
    }
  }

  handleLoginPSA = (value, data) => {
    if (data != null) {
      this.isRedirect = false;
      if (data.error) {
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: true,
          msgVentana: data.mensaje,
        })
      } else {
        localStorage.setItem("tokenIscert", data.datos.access_token)
        localStorage.setItem("codigoClienteFirma", this.datosPsa.id)
        localStorage.setItem("proveedorFirma", this.datosPsa.codigoCliente)
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: false,
          msgVentana: "Autenticado con exito",
        })
      }
    } else {
      this.setState({
        openLoginPSA: value
      })
    }
  }

  enviarComentario = (event) => {
    event.preventDefault();
    this.setState({ validated: true, openComentarioFirma: false, openPantallaCarga: true, msgPantallaCarga: "Enviando comentario" })
    let data = {
      batchId: this.props.match.params.idLote,
      payrollId: this.props.match.params.idRecibo,
      appearance: "",
      redirectUri: "",
      employeeComment: this.state.comentarioFirma
    }

    enviarComentarioFirma(data).then(res => {
      this.setState({ redirect: true })
    })
  }

  handleOpenComentarioFirma = (value) => {
    this.setState({
      openMsgVentana: false,
      openComentarioFirma: value
    })
    if (!value)
      this.setState({ redirect: true })
  }

  handleClose = (value) => {
    this.setState({
      open: value
    });
  };

  rechazarDocumento = (motivoRechazo) => {
    rechazarLote(this.props.match.params.idLote, this.props.match.params.idRecibo, motivoRechazo).then((response => {
      this.props.history.push({
        pathname: '/bandeja/rechazados',
        state: {
          mensajeFlash: !response.error ? 'Documento rechazado exitosamente' : 'Ocurrio un error al rechazar documento',
          mostrarMensajeFlash: true,
          mensajeFlashSeverity: response.error ? 'error' : 'exito',
        }
      })
    }))
  }

  rechazarLote = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      this.setState({ validated: true })
    } else {
      rechazarLote(this.props.match.params.idLote, this.props.match.params.idRecibo, this.state.mensajeRechazar).then((response => {
        this.isRedirect = true
        this.setState({
          openRechazar: false,
          openMsgVentana: true,
          msgVentana: response.mensaje,
          isRechazado: true,
        })
      }))
    }
  }

  aceptarRecibo = () => {
    this.setState({ openPantallaCarga: true })
    aceptarEmpleado(this.props.match.params.idLote, this.props.match.params.idRecibo)
      .then((response) => {
        this.props.history.push({
          pathname: '/recibo/aceptar/' + (response.data.error ? 'error' : 'exito'),
          state: {
            descripcionLote: this.state.concepto,
            fechaImportacionLote: this.state.fecha,
            errorDetalle: response.data.error ? response.data.mensaje : null,
            comentarioFirma: this.state.enableComentarioFirma,
            backUrl: this.props.location.pathname
          }
        });
      })
  }

  descargarRecibo = () => {
    window.location.href = URL + "recibo/lote/" + this.props.match.params.idLote + "/recibo/" + this.props.match.params.idRecibo + "/descargar";
  }

  visualizarBotones = () => {
    if (this.props.match.params.estado == "Firmados") {
      return null
    }
    if (this.props.match.params.estado == "Confirmados") {
      return null
    }
    if (this.props.match.params.estado == "Pendientes" && [firmaColaborador, firmaColaboradorRechazar].includes(this.state.tipoFirma)) {
      return (<button className="btn-medium btn-primary" onClick={this.handleDialogPin}> <span className="material-symbols-outlined">history_edu</span> Firmar </button>)
    }
    if (this.props.match.params.estado == "Rechazados") {
      return null
    }
  }
  botonRechazar = () => {
    if (this.props.match.params.estado == "Pendientes" && [firmaColaboradorRechazar, aceptarRechazar].includes(this.state.tipoFirma)) {
      return (<button className="btn-medium btn-danger" onClick={this.handleClickOpen}> <span className="material-symbols-outlined">close</span> Rechazar </button>)
    }
  }
  botonAceptarSinFirma = () => {
    if (this.props.match.params.estado == "Pendientes" && [aceptar, aceptarRechazar].includes(this.state.tipoFirma)) {
      return (
        <button onClick={() => this.handleDialogConfirmarSinFirma(true)} className="btn-medium btn-primary">
          <span className="material-symbols-outlined">thumb_up</span> Aceptar
        </button>
      )
    }
  }

  handleDialogConfirmarSinFirma = (value) => {
    this.setState({
      openMsgAceptarFirma: value,
    })

  }

  publicarLote = () => {
    publicarLote(this.props.match.params.idLote).then((response) => {
      this.setState({
        openMsgVentana: true,
        msgVentana: response.mensaje
      })
      this.handleClose(false);
    });
    this.tableRef.current.onQueryChange();
  }
  urlPDF = () => {
    var request = URL + 'recibo/lote/' + this.props.match.params.idLote + '/recibo/' + this.props.match.params.idRecibo;
    return request
  }

  handleClickOpen = () => {
    this.setState({ openRechazar: true });
  };

  handleCloseRechazar = () => {
    this.setState({
      openRechazar: false,
    });
  };

  render() {

    return (
      <div className="template-base">
        <PinEmpleado
          estado={this.props.match.params.estado}
          idLote={this.props.match.params.idLote}
          idRecibo={this.props.match.params.idRecibo}
          loteRecibo={this.state.loteRecibo}
          fecha={this.state.fecha}
          concepto={this.state.concepto}
          type={this.state.dialogType}
          formatoDocumento={this.state.formatoDocumento}
          submitText={this.state.submitText}
          disabledInput={this.state.disabledInput}
          handleClose={this.handleDialogPin}
          isOpen={this.state.dialogPinOpen}
          dialogTitle={this.state.dialogTitle}
        />

        <ModalMensajePersonalizado
          ref={this.modalMensaje}
          isOpen={this.state.openMsgVentana}
          error={this.state.error}
          msg={this.state.msgVentana}
          accion={() => this.handleMsgVentana(false)}
          onClose={() => this.setState({ openMsgVentana: false })}
        />

        <ModalRechazarRecibo
          ref={(ref) => (this.modalRechazarRecibo = ref)}
          isOpen={this.state.openRechazar}
          cerrarModal={this.handleCloseRechazar}
          onConfirmar={this.rechazarDocumento}
        />


        <SeleccionPca
          ref={this.modalSeleccionPsa}
          isOpen={this.state.openSeleccionPca}
          cerrarModal={this.handleClosePsa}
          url={window.location.href}
          listaPsa={this.psaActivos}
          idRecibo={this.props.match.params.idRecibo}
          idLote={this.props.match.params.idLote}
        />

        <ModalAceptarLote
          ref={this.modalAceptarLote}
          isOpen={this.state.openMsgAceptarFirma}
          onConfirmar={this.aceptarRecibo}
          tipoDocumento="documento"
          cerrarModal={() => this.handleDialogConfirmarSinFirma(false)}
        />

        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.openLoginPSA}
          onHide={() => this.handleLoginPSA(false, null)}
          backdrop="static"
          keyboard="false"
        >
          <LoginPsa
            handleClose={this.handleLoginPSA}
            data={this.datosPsa}
          />
        </Modal>

        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={this.setPantallaAnterior()}
              breadcrumbs={
                [
                  { label: 'Bandejas', path: this.setPantallaAnterior() },
                  { label: 'Visor de documento', path: '' }
                ]
              }
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> {this.state.concepto} </h1>
                <p className="page-description"> Puedes firmar el documento desde aqui o descargarlo </p>
              </div>
              <div className="head-actions">
                {this.visualizarBotones()}

                {this.botonAceptarSinFirma()}

                {this.botonRechazar()}

                <button className="btn-medium btn-base-outline" onClick={this.descargarRecibo}>
                  <span className="material-symbols-outlined">download</span> Descargar
                </button>
              </div>
            </div>

          </div>
        </header>
        <div className="wrapperContent">
          <div className="component-documento">
            <div className="page-container container-sm">

              <div className="card">

                <div id="container-file">
                  <iframe
                    id="pdf-js-viewer"
                    //src="/visor/viewer.html?file="
                    src="/mirecibo/visor/viewer.html?file="
                    title="webviewer"
                    frameBorder="0"
                    width="100%"
                    height="1000px"
                  ></iframe>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div >
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getRecibos: (page, size, search, idLote) => dispatch(getRecibos(page, size, search, idLote)),
});

const mapStateToProps = (state) => ({
  recibosData: state.recibosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReciboEmpleado);